import Tail from './Tail';

export default Tail;
